import { InjectionToken } from '@angular/core';

export const Environment: InjectionToken<any> = new InjectionToken('PORTAL_ENVIRONMENT');
